import React from 'react'
import PropTypes from 'prop-types'
import WrappedDrawer from '@/components/WrappedDrawer'
import TherapistDetail from './TherapistDetail'

class TherapistDetailDrawer extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    record: PropTypes.object
  }

  render () {
    const { children, record } = this.props
    return (
      <WrappedDrawer
        children={children}
        title="师傅详情"
        width={420}
        footer={null}
        maskClosable={true}
        destroyOnClose={true}
        baseComponent={<TherapistDetail />}
        baseProps={{ record }}
      />
    )
  }
}

export default TherapistDetailDrawer
